import PermissionButton from '../../permissions/PermissionButton';
import React, { useState, useEffect } from 'react';
import { Modal, Radio, Space, Button, Progress } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { message } from 'antd';

const PrintDialog = ({ 
  open, 
  onClose, 
  onPrint, 
  onPreview, 
  onPrintEmplacement, 
  onPreviewEmplacement,
  devisRef,
  isBulkPrint = false,
  currentDevisIndex = 0,
  totalDevis = 0,
  onBreakPrinting,
  onNextDevis,
  onPreviousDevis,
  hasNextDevis,
  hasPreviousDevis
}) => {
  const [printType, setPrintType] = useState('emplacement');
  const [isPrinting, setIsPrinting] = useState(false);
  
  useEffect(() => {
    if (isBulkPrint) {
      setPrintType('external');
    }
  }, [isBulkPrint]);

  const handlePrint = async () => {
    setIsPrinting(true);
    try {
      if (printType === 'both') {
        // First complete the internal print with proper error handling
        try {
          await onPrintEmplacement();
          await onPrint('internal');
          console.log('Internal print completed');
          
          // Then start the emplacement print
          
          console.log('Emplacement print completed');
        } catch (printError) {
          console.error('Error during combined printing sequence:', printError);
          throw printError;
        }
      } else if (printType === 'emplacement') {
        await onPrintEmplacement();
      } else {
        await onPrint(printType);
      }
    } catch (error) {
      console.error('Error during printing:', error);
    } finally {
      setIsPrinting(false);
    }
  };
  
  const handlePreview = async () => {
    if (printType === 'both') {
      message.warning('L\'aperçu n\'est pas disponible pour l\'impression combinée');
      return;
    }
    setIsPrinting(true);
    try {
      if (printType === 'emplacement') await onPreviewEmplacement();
      else await onPreview(printType);
    } finally {
      setIsPrinting(false);
    }
  };

  const isFloorBatch = isBulkPrint && printType === 'external';
  const dialogTitle = isFloorBatch ? `Ventilés par étage — ${totalDevis} devis` : devisRef
    ? `Format d'impression - Devis ${devisRef}` 
    : `Format d'impression`;

  const footerButtons = [
    <Button 
      key="preview" 
      style={{ backgroundColor: '#1890ff', color: 'white' }} 
      onClick={handlePreview}
      disabled={isPrinting || printType === 'both'}
    >
      Aperçu
    </Button>,
    <PermissionButton permissionModule="quotes" permissionAction="print"
      key="print" 
      type="primary" 
      onClick={handlePrint}
      loading={isPrinting}
    >
      {isFloorBatch ? 'Imprimer tous les ventilés' : 'Imprimer'}
    </PermissionButton>
  ];

  if (isBulkPrint && !isFloorBatch) {
    footerButtons.splice(1, 0, 
      <Button 
        key="previous"
        icon={<LeftOutlined />}
        onClick={onPreviousDevis}
        disabled={!hasPreviousDevis || isPrinting}
      >
        Précédent
      </Button>,
      <Button 
        key="next"
        icon={<RightOutlined />}
        onClick={onNextDevis}
        disabled={!hasNextDevis || isPrinting}
      >
        Suivant
      </Button>
    );
  }

  return (
    <Modal
      title={dialogTitle}
      open={open}
      onCancel={isPrinting ? undefined : onClose}
      closable={!isPrinting}
      maskClosable={!isPrinting}
      footer={footerButtons}
    >
      {isBulkPrint && !isFloorBatch && (
        <div style={{ marginBottom: 16 }}>
          <Progress 
            percent={Math.round((currentDevisIndex / totalDevis) * 100)} 
            status="active" 
            format={() => `${currentDevisIndex + 1}/${totalDevis}`}
          />
        </div>
      )}

      <p style={{ marginBottom: 16 }}>Choisissez le format d'impression souhaité:</p>
      {isFloorBatch && <p>Tous les ventilés de l'étage 1, puis de l'étage 2, etc., pour les {totalDevis} devis sélectionnés, en une seule impression A5 paysage.</p>}

      <Radio.Group
        value={printType}
        onChange={(e) => setPrintType(e.target.value)}
        disabled={isPrinting}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Radio value="both">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Devis Master + Emplacement</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                Imprime les deux formats en une seule action
              </div>
            </Space>
          </Radio>
          <Radio value="internal">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Devis Master</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                Format détaillé avec toutes les informations
              </div>
            </Space>
          </Radio>
          <Radio value="commercial">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Commercial</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                Format commercial sans colonnes Etage, Qte liv, cont
              </div>
            </Space>
          </Radio>
          <Radio value="external">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Ventilé / Par Etage</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                A5 paysage · Étages à visiter, remarque livraison et préparation
              </div>
            </Space>
          </Radio>
          <Radio value="emplacement">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Emplacement</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                Format paysage à placer avec les colis
              </div>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default PrintDialog;
